import type { AvailableLanguages } from '@context'

/** DB has nameFr (default), nameEn, and nameEs. Match API get-reference / profile behavior. */
export function localizedReferenceName(
  lang: AvailableLanguages,
  nameFr: string,
  nameEn: string,
  nameEs?: string,
): string {
  if (lang === 'fr') return nameFr
  if (lang === 'es') return nameEs ?? nameEn
  return nameEn
}
